import styled from "styled-components";

export const Container = styled.footer`
	background-color: var(--dark-blue);
	color: white;

	padding: 20px 0;
	.col {
		width: 50%;

		p,
		a,
		li {
			text-overflow: ellipsis;
			white-space: nowrap;
			overflow: hidden;
		}
	}

	a {
		color: var(--light-green);
		padding: 5px;
	}
	a:hover {
		cursor: pointer;
		text-decoration: underline;
	}

	li {
		margin: 15px 5px;
	}
	ul {
		overflow-y: hidden;
	}
	.float-btn {
		position: fixed;
		right: 30px;
		bottom: 30px;
		transition: 600ms;
	}
	.float-btn:hover {
		scale: 1.2;
	}
	.whatsapp {
		background-color: var(--main-green);
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		width: 50px;
		height: 50px;
		border-radius: 1000px;

		-webkit-box-shadow: 10px 10px 25px -13px rgba(0, 0, 0, 0.75);
		-moz-box-shadow: 10px 10px 25px -13px rgba(0, 0, 0, 0.75);
		box-shadow: 10px 10px 25px -13px rgba(0, 0, 0, 0.75);
	}
`;
export const Wrapper = styled.div`
	max-width: 1400px;
	margin: 0 auto;

	display: flex;

	@media (max-width: 795px) {
		flex-direction: column;
		align-items: center;

		.col {
			width: calc(100vw - 5%);
			p,
			a,
			li {
				font-size: 14px;
			}
		}
	}
	@media (max-width: 400px) {
		width: 100vw;
		p,
		a,
		li {
			font-size: 10px;
		}
	}
`;
